import firebase from 'firebase/app'
import 'firebase/firestore'

  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyCLv6Ihmz0njLENlmJbvZ4OlR5n3CWNtcs",
    authDomain: "polypods-4a1dd.firebaseapp.com",
    databaseURL: "https://polypods-4a1dd.firebaseio.com",
    projectId: "polypods-4a1dd",
    storageBucket: "polypods-4a1dd.appspot.com",
    messagingSenderId: "156467543330",
    appId: "1:156467543330:web:022bd70dbd7a61a6edf97b"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);


export default firebase